import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import { Config } from '../config';
import { socketio } from '../api/socket.api';
import { ComPushProtocol } from '../api/socket.protocol';
import { useSetRecoilState } from 'recoil';
import eventbus from '../api/eventbus';
import {
  fullLoadingStateRecoil,
  socketInitializeRecoil,
} from '../atom/CommonAtom';
import { roomIdStateRecoil } from '../atom/RoomAtom';
import { errorMsgRecoil } from '../atom/ModalAtom';

const socket = io(String(Config.SOCKET_URL), { transports: ['websocket'] });

export default function SocketIo() {
  const navigate = useNavigate();

  const setSocketInitialize = useSetRecoilState(socketInitializeRecoil);
  const setFullLoading = useSetRecoilState(fullLoadingStateRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);

  useEffect(() => {
    socket.on('connect', () => {
      if (socketio.initialize(socket)) {
        setSocketInitialize(true);
        setFullLoading(false);
      }
    });

    socket.on('disconnect', () => {
      socketio.finalize();
      setSocketInitialize(false);
      setFullLoading(true);
    });

    socket.on(ComPushProtocol.pushParticipation, (data) => {
      console.log(`${ComPushProtocol.pushParticipation}`, data);
      eventbus.emit('participation', {});
    });

    socket.on(ComPushProtocol.pushEntry, (data) => {
      console.log(`${ComPushProtocol.pushEntry}`, data);
      eventbus.emit('entry', {});
    });

    socket.on(ComPushProtocol.pushAutoSort, (data) => {
      console.log(`${ComPushProtocol.pushAutoSort}`, data);
      eventbus.emit('autosort', {});
    });

    socket.on(ComPushProtocol.pushEntryOrder, (data) => {
      console.log(`${ComPushProtocol.pushEntryOrder}`, data);
      eventbus.emit('entryOrder', {});
    });

    socket.on(ComPushProtocol.pushEntryCancel, (data) => {
      console.log(`${ComPushProtocol.pushEntryCancel}`, data);
      eventbus.emit('entryCancel', {});
    });

    socket.on(ComPushProtocol.pushNoticeUpdate, (data) => {
      console.log(`${ComPushProtocol.pushNoticeUpdate}`, data);
      eventbus.emit('noticeUpdate', { roomId: data.roomId });
    });

    socket.on(ComPushProtocol.pushEntrySiteUpdate, (data) => {
      console.log(`${ComPushProtocol.pushEntrySiteUpdate}`, data);
      eventbus.emit('entrySiteUpdate', {});
    });

    return () => {
      //socket.off('connect');
      //socket.off('disconnect');
      //socket.off(ComPushProtocol.pushParticipation);
      //socket.off(ComPushProtocol.pushEntry);
      //socket.off(ComPushProtocol.pushAutoSort);
      //socket.off(ComPushProtocol.pushEntryOrder);
      //socket.off(ComPushProtocol.pushEntryCancel);
    };
  }, []);
  return <div></div>;
}
